import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import {
  BUILD_ID,
  isScrollIntendedLocked,
  enforceScrollState,
} from './scrollLockState';

export { BUILD_ID };

export const useScrollWatchdog = () => {
  const location = useLocation();

  // Enforce on mount + hydration timers
  useEffect(() => {
    console.log(`[Build] ${BUILD_ID}`);
    enforceScrollState();

    const hydrationTimer = setTimeout(() => {
      if (!isScrollIntendedLocked()) enforceScrollState();
    }, 150);

    const slowTimer = setTimeout(() => {
      if (!isScrollIntendedLocked()) enforceScrollState();
    }, 500);

    const handleVisibilityChange = () => {
      if (document.visibilityState === 'visible' && !isScrollIntendedLocked()) {
        enforceScrollState();
      }
    };
    document.addEventListener('visibilitychange', handleVisibilityChange);

    return () => {
      clearTimeout(hydrationTimer);
      clearTimeout(slowTimer);
      document.removeEventListener('visibilitychange', handleVisibilityChange);
    };
  }, []);

  // Enforce on route change
  useEffect(() => {
    const timer = setTimeout(() => {
      if (!isScrollIntendedLocked()) enforceScrollState();
    }, 150);
    return () => clearTimeout(timer);
  }, [location.pathname]);
};
